export const initialAHIOptions = {
  background: true,
  border: true,
  font: 2,
  bright: 80,
};
